import React from "react";
import { Link } from "react-router-dom";
import "./error.scss";
import QueueRoutes from "./QueueRoutes";

const Error = ({ code, message, queue="", buttonText = "Home", link = "/" }) => {
	return (
		<div className="error">
			<h5>{code}</h5>
			<h1>{message}</h1>
			<Link to={link} className="home">Go {buttonText}</Link>
			<QueueRoutes queue={queue} />
		</div>
	);
};

export default Error;
